<template>
    <div :class="'tutoriais-relacionados-container tutorial-size-' + this.size + (this.carousel?' carousel':'')">
        <h1>Tutoriais Relacionados</h1>
        <div class="tutoriais-relacionados-row">
            <b-link v-for="tutorial in tutoriaisRelacionados" :class="'tutorial-element ' + (tutorialTitle?'tutorial-description':'tutorial-thumb')" :href="tutorial.href">
                <div class="tutorial-element-img-container">
                    <img :src="getTutorialThumb(tutorial.thumbnail)" :alt="tutorial.descricao"/>
                </div>
                <h3 v-if="tutorialTitle">{{tutorial.titulo}}</h3>
            </b-link>
        </div>
        <b-link v-if="tutoriasCaller" href="/ajuda">
            <div class="tutoriais-relacionados-caller">
                <h2>Assista nossos tutoriais</h2>
                <div class="tutoriais-caller-img-container">
                    <img src="@/assets/imgs/tutoriais_mascara.png"/>
                </div>
            </div>
        </b-link>
    </div>
</template>
<script>
import { CarouselPlugin } from 'bootstrap-vue';
export default {
    components: {CarouselPlugin},
    props:{
        size:'',
        tutoriasCaller: Boolean,
        tutorialTitle: false,
        carousel: false
    },
    data() {
        return {
            mobile:window.innerWidth < 1200,
            tutoriaisRelacionados:[],
            tutoriaisData:[
                {
                    thumbnail:'27.jpg',
                    descricao:'tutorial 1',
                    titulo: 'Nunc condimentum mauris porttitor varius imperdiet. Aliquam nibh tortor, tristique in consequat sit amet, tempor ut ipsum',
                    href:'/ajuda'
                },
                {
                    thumbnail:'8.jpg',
                   descricao:'tutorial 2',
                   titulo: 'Vivamus auctor feugiat lorem, quis imperdiet dolor dapibus nec',
                   href:'/ajuda'
                },
                {
                    thumbnail:'15.jpg',
                    descricao:'tutorial 3',
                    titulo: 'Cras lobortis in felis at commodo. Etiam laoreet ligula at dolor aliquet, et viverra ante imperdiet',
                    href:'/ajuda'
                },
                {
                    thumbnail:'03@2x.png',
                    descricao:'tutorial 4',
                    titulo: 'Nunc condimentum mauris porttitor varius imperdiet. Aliquam nibh tortor, tristique in consequat sit amet, tempor ut ipsum',
                    href:'/ajuda'
                },
            ],
        };
    },
    methods: {
        getTutorialThumb(imageSrc) {
            if (imageSrc.includes('png')) {
                var images = require.context('../../assets/imgs/', false, /\.png$/);
            } else {
                var images = require.context('../../assets/imgs/', false, /\.jpg$/);
            }
            return images('./' + imageSrc)
        },
        getTutoriais(size){
            var tutoriais = [];
            for (let index = 0; index < this.size; index++) {
                tutoriais[index] = this.tutoriaisData[index];
            }
            return tutoriais;
        }
    },
    beforeMount(){
        this.tutoriaisRelacionados = this.getTutoriais(this.size);
    }
}
</script>
<style scoped>
.tutoriais-relacionados-container {display: flex;flex-flow: column;width: 100%; }
    .tutoriais-relacionados-container h1{text-align: left;font: normal normal normal 20px/27px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin-bottom: 24px;}
    .tutoriais-relacionados-container  a:hover{text-decoration: none;}
    .tutoriais-relacionados-container .tutoriais-relacionados-row{display: flex;width: 100%;justify-content: space-between;margin-bottom: 12px;}
        .tutoriais-relacionados-container .tutoriais-relacionados-row .tutorial-element {display: flex;flex-flow: column;}
                .tutoriais-relacionados-container.tutorial-size-2 .tutoriais-relacionados-row .tutorial-element{flex: 0 0 47.84%;max-width: 47.84%;}
                .tutoriais-relacionados-container.tutorial-size-3 .tutoriais-relacionados-row .tutorial-element{flex: 0 0 30.45%;max-width: 30.45%;}
                .tutoriais-relacionados-container.tutorial-size-4 .tutoriais-relacionados-row .tutorial-element{flex: 0 0 23.92%;max-width: 23.92%;}
            .tutoriais-relacionados-container .tutoriais-relacionados-row .tutorial-element h3 {font: normal normal bold 20px/27px 'Kanit', sans-serif; letter-spacing: 0px;color: #707070;margin:0;height: fit-content;}
            .tutoriais-relacionados-container .tutoriais-relacionados-row .tutorial-element .tutorial-element-img-container{width: 100%;display: flex;justify-content: center;align-items: center;overflow: hidden;margin-bottom: 18px;}
                .tutoriais-relacionados-container .tutoriais-relacionados-row .tutorial-element .tutorial-element-img-container img{height: 100%;width: 100%;object-fit: cover;filter: brightness(0.5);left: 12px;position: relative;}
                .tutoriais-relacionados-container .tutoriais-relacionados-row .tutorial-element .tutorial-element-img-container::after{content: '';width: 23.5px;height: 29.5px;border-left: 23.5px solid white;border-top: 14.75px solid transparent;border-bottom: 14.75px solid transparent;position: relative;left: -50%;z-index: 1;}
                    .tutoriais-relacionados-container .tutoriais-relacionados-row .tutorial-element.tutorial-description .tutorial-element-img-container{height: calc(186px + 18px);}
                    .tutoriais-relacionados-container .tutoriais-relacionados-row .tutorial-element.tutorial-thumb .tutorial-element-img-container{height: calc(219px + 18px);}
    .tutoriais-relacionados-container .tutoriais-relacionados-caller{width: 100%;height: 95px;overflow: hidden;position: relative;display: flex;align-items: center;}
        .tutoriais-relacionados-container .tutoriais-relacionados-caller h2{font: normal normal bold 30px/41px 'Kanit', sans-serif; letter-spacing: 0px;color: #F1F1F1;margin: 0;position: absolute;z-index: 2;padding-left: 49px;}
        .tutoriais-relacionados-container .tutoriais-relacionados-caller .tutoriais-caller-img-container {height: inherit;width: inherit;overflow: hidden;position: absolute;z-index: 1;}
            .tutoriais-relacionados-container .tutoriais-relacionados-caller .tutoriais-caller-img-container img{height: inherit;width: inherit;object-fit: cover;z-index: 1;}

    @media (max-width: 1399px) and (min-width: 1200px){
        .tutoriais-relacionados-container .tutoriais-relacionados-row .tutorial-element h3{font-size: 0.9375rem; line-height: 1.26rem;}
        .tutoriais-relacionados-container .tutoriais-relacionados-row .tutorial-element.tutorial-description .tutorial-element-img-container{height: 153px;}
    }
    @media (max-width: 1199px) {
        .tutoriais-relacionados-container.carousel{margin-left: 20px;margin-bottom: 66px;}
        .tutoriais-relacionados-container.carousel .tutoriais-relacionados-row{width: calc(100% - 20px);overflow-x: scroll;scrollbar-width:none;}
        .tutoriais-relacionados-container.carousel .tutoriais-relacionados-row::-webkit-scrollbar{display: none;}
        .tutoriais-relacionados-container.carousel.tutorial-size-4 .tutoriais-relacionados-row .tutorial-element{width: 284px;min-width: 284px;max-width: unset;flex: unset;margin-right: 26px;}
        .tutoriais-relacionados-container.carousel .tutoriais-relacionados-row .tutorial-element .tutorial-element-img-container{margin-bottom: 16px;height: 165px;}
        .tutoriais-relacionados-container .tutoriais-relacionados-caller{height: 133px;}
        .tutoriais-relacionados-container .tutoriais-relacionados-caller h2{font:normal normal bold 20px/27px 'Kanit', sans-serif;}

        .tutoriais-relacionados-container.tutorial-size-2 h1{display: none;}
        .tutoriais-relacionados-container.tutorial-size-2 .tutoriais-relacionados-row .tutorial-element{flex: 0 0 49%;max-width: 49%;}
        .tutoriais-relacionados-container.tutorial-size-2 .tutoriais-relacionados-row .tutorial-element.tutorial-thumb .tutorial-element-img-container{height: 100%;margin-bottom: 0;}
    }
    @media (max-width: 780px) {
        .tutoriais-relacionados-container.tutorial-size-2 .tutoriais-relacionados-row{flex-flow: column;margin-bottom: 0;}
        .tutoriais-relacionados-container.tutorial-size-2 .tutoriais-relacionados-row .tutorial-element{flex: unset;max-width: unset;width: 100%;margin-bottom: 38px;}
        .tutoriais-relacionados-container.tutorial-size-2 .tutoriais-relacionados-row .tutorial-element .tutorial-element-img-container img{height:calc((100vw - 40px) / 1.806);}
        
    }

</style>